import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { IDashboard, IDropDown, IDropDownItem } from "../../interfaces/idashboard";
import { IRegion } from "../../interfaces/iregion";
import { ICountry } from "../../interfaces/icountry";

import { ICountryMap, CountryMapZoom } from "../../interfaces/icountrymap";
import { DashboardService } from "../../services/dashboard.service";
import { RegionService } from "../../services/region.service";
import { CountryMapService } from "../../services/countrymap.service";

@Component({
    selector: "dashboard",
    templateUrl: "./dashboard.component.html",
    providers: [CountryMapService],
    standalone: false
})
export class DashboardComponent implements OnInit {
    dashboard!: IDashboard;
    // regions and Countries received from Service
    regions: IRegion[] = new Array();
    countries: ICountry[] = new Array();

    // regions and Countries as a list to show in the resp. dropdowns
    itemsRegions: IDropDownItem[] = new Array();
    itemsCountries: IDropDownItem[] = new Array();
    itemsCountriesCategoryDetail: IDropDownItem[] = new Array();
    // regions and Countries selected dropdown Items
    selectedRegion: number | null = null;
    selectedCountry: number | null = null;

    dropDownsToRender: IDropDown[] = new Array();

    keySelected: number | null = null;
    dataTable: ICountryMap[] = new Array();

    countryMapFilter: CountryMapZoom = new CountryMapZoom();

    constructor(private dashboardService: DashboardService, private regionService: RegionService, private countryMapService: CountryMapService, private activatedRoute: ActivatedRoute) {
    }

    ngOnInit(): void {
        // get list of countries with category details attached to them
        this.activatedRoute.snapshot.data['countriesWithCategoryDetail'].map((country: ICountry) => {
            this.countries.push(country);
            this.itemsCountriesCategoryDetail.push({ id: country.id, text: country.shortName, colour: "" });
        });
        this.itemsCountries = this.itemsCountriesCategoryDetail;
        this.populateUiModel(this.activatedRoute.snapshot.data['dashboard']);
        this.regions = this.activatedRoute.snapshot.data['regions'];
        this.regions.forEach(rgn => {
            this.itemsRegions.push({ id: rgn.id, text: rgn.name, colour: "" });
        });
    }

    populateUiModel(dashboard: IDashboard): void {
        this.dashboard = dashboard;
        this.createDropDownHierarchy(null, null); // pass in null as first time round
        this.getDataForMap();
    }

    getDataForMap(): void {
        this.countryMapFilter.countryMap = this.dashboardService.getDataForMap(this.dropDownsToRender, this.keySelected);
        this.countryMapService.announceDropDownsChanged(this.countryMapFilter);
    }

    createDropDownHierarchy(dropdownChanged: IDropDown | null, selectedItem: IDropDownItem | null): void {
        this.keySelected = null;
        this.dropDownsToRender = this.dashboardService.getDropDownsToRender(this.dashboard.dropDowns, dropdownChanged, selectedItem);
    }

    onDashboardDropDownSelected(selectedItemId: number, dropdown: IDropDown): void {
        const selectedItem = dropdown.dropDownItems.find(item => item.id === selectedItemId);
        if (selectedItem) {
            this.onDashboardDropDownChange(selectedItem, dropdown);
        }
    }

    onDashboardDropDownChange(selectedItem: IDropDownItem, dropdown: IDropDown): void {
        this.createDropDownHierarchy(dropdown, selectedItem);
        this.getDataForMap();
    }

    /**
     * On selected region changes, filter the country dropdown accordingly.
     * @param selectedRegion The selected region value.
     */
    onRegionSelected(selectedRegion: any): void {
        if (selectedRegion) {
            this.selectedRegion = selectedRegion;
            this.setCountriesAndMap(selectedRegion);
        }
    }

    setCountriesAndMap(regionId: number): void {
        this.itemsCountries = new Array();
        this.selectedCountry = null; // reset the country dropdown to blank

        let regionCode: string = "world";
        if (regionId !== -1) {

            let selCountries: ICountry[] = this.countries.filter(function (row: ICountry): any {
                return row.regionId === regionId;
            });

            selCountries.forEach(c => { this.itemsCountries.push({ id: c.id, text: c.shortName, colour: "" }); });
            regionCode = this.regions.filter(r => r.id === regionId)[0].code.toString();
            regionCode = this.padCountryRegion(regionCode);
        } else {
            this.countries.forEach(c => { this.itemsCountries.push({ id: c.id, text: c.shortName, colour: "" }); });
        }

        this.countryMapFilter.regionCountryCode = regionCode;
        this.getDataForMap();
    }

    /**
     * On selected region removed, reset the country dropdown and reset the map focus.
     * @param removedRegion The removed region value.
     */
    onRegionRemoved(removedRegion: any): void {
        this.selectedRegion = null;
        this.selectedCountry = null;
        this.setCountriesAndMap(-1);
        this.fiterMapForCountry("-1");
    }

    /**
     * On selected country changes, filter the map data accordingly and set the map focus.
     * @param selectedCountry The selected country value.
     */
    onCountrySelected(selectedCountry: any): void {
        if (selectedCountry) {
            this.selectedCountry = selectedCountry;
            var countryVal: ICountry | undefined = this.countries.find(c => c.id === selectedCountry);
            if (countryVal) {
                this.fiterMapForCountry(countryVal.code);
            }
        }
    }

    /**
     * On selected country removed, reset the map focus.
     * @param removedCountry The removed country value.
     */
    onCountryRemoved(removedCountry: any): void {
        this.selectedCountry = null;
        if (this.selectedRegion != null && this.selectedRegion !== -1) {
            this.setCountriesAndMap(this.selectedRegion);
        } else {
            this.fiterMapForCountry("-1");
        }
    }

    fiterMapForCountry(countryCode: string): void {
        this.countryMapFilter.regionCountryCode = countryCode !== "-1" ? countryCode : "world";
        this.getDataForMap();
    }

    keyItemSelected(dropdown: IDropDown, keyItemId: number): void {
        this.keySelected = keyItemId;
        this.getDataForMap();
    }

    /**
     * On reset button clicked.
     * Reset the filters on the dashboard to its original values.
     */
    onResetClicked(): void {
        this.selectedCountry = null;
        this.itemsCountries = this.itemsCountriesCategoryDetail;
        this.selectedRegion = null;
        this.countryMapFilter.regionCountryCode = "world";
        this.keySelected = null;
        this.getDataForMap();
    }

    padCountryRegion(code: string): string {
        let pad: string = "000".substring(code.length);
        return pad + code;
    }
}
